/**
 * @generated SignedSource<<19559a03f8f7c0c1076cb3dac71205a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FocusRoadmapSkillsQuery$variables = {
  targetGroupId: number;
};
export type FocusRoadmapSkillsQuery$data = {
  readonly targetGroup: {
    readonly id: string;
    readonly targets: ReadonlyArray<{
      readonly id: string;
      readonly targetSkills: ReadonlyArray<{
        readonly skill: {
          readonly id: string;
        } | null | undefined;
        readonly targetSkillType: {
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type FocusRoadmapSkillsQuery = {
  response: FocusRoadmapSkillsQuery$data;
  variables: FocusRoadmapSkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetGroupId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "targetGroupId",
    "variableName": "targetGroupId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "isActive": "ACTIVE"
    }
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "skill",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FocusRoadmapSkillsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TargetGroupNode",
        "kind": "LinkedField",
        "name": "targetGroup",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TargetNode",
            "kind": "LinkedField",
            "name": "targets",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetSkillNode",
                "kind": "LinkedField",
                "name": "targetSkills",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TargetSkillTypeNode",
                    "kind": "LinkedField",
                    "name": "targetSkillType",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "targets(filter:{\"isActive\":\"ACTIVE\"})"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FocusRoadmapSkillsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TargetGroupNode",
        "kind": "LinkedField",
        "name": "targetGroup",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TargetNode",
            "kind": "LinkedField",
            "name": "targets",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TargetSkillNode",
                "kind": "LinkedField",
                "name": "targetSkills",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TargetSkillTypeNode",
                    "kind": "LinkedField",
                    "name": "targetSkillType",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "targets(filter:{\"isActive\":\"ACTIVE\"})"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7677bfbaa006534384537d7c3402f663",
    "id": null,
    "metadata": {},
    "name": "FocusRoadmapSkillsQuery",
    "operationKind": "query",
    "text": "query FocusRoadmapSkillsQuery(\n  $targetGroupId: Int!\n) {\n  targetGroup(targetGroupId: $targetGroupId) {\n    id\n    targets(filter: {isActive: ACTIVE}) {\n      id\n      targetSkills {\n        targetSkillType {\n          name\n          id\n        }\n        skill {\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b3fd55d6b087cc9f0175602fa15d186b";

export default node;
